var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('map-card',{attrs:{"height":720,"title":'Map View: ' + _vm.title,"markers":_vm.deviceList,"categories":_vm.categoryDefs,"map-icons":_vm.mapIconDefs,"popup-headers":_vm.popupHeaders,"detail-headers":_vm.detailHeaders}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }